import {TopicModel} from '../../../models/api/topicModel';
import {ThunkAction} from '../../appThunk';
import {updateDataAction} from '../dataGroupsActions';
import {getTopics} from '../dataSelectors';

/*
 * Actions.
 */

export function updateTopicAction(updatedTopic: TopicModel): ThunkAction {
  return (dispatch, getState) => {
    // Find the existing topic.
    const existingTopic = getTopics(getState())[updatedTopic.id];

    // If we do not have an existing topic, return.
    if (!existingTopic) {
      return;
    }

    // No need to do anything if the new topic is older.
    if (existingTopic && existingTopic.updatedAt > updatedTopic.updatedAt) {
      return;
    }

    // Otherwise, update the card.
    dispatch(updateDataAction({topics: [updatedTopic]}));
  };
}
